import script from "./MessagingReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessagingReports.vue?vue&type=script&lang=ts&setup=true"

import "./MessagingReports.vue?vue&type=style&index=0&id=8da029d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8da029d6"]])

export default __exports__